import { createAction, props } from '@ngrx/store';
import { Reasoning } from 'src/app/model/reasoning/Reasoning';

export enum ReasoningActionTypes {
    UpdateReasoning = '[Reasoning] Update Reasoning',
    ClearReasonings = '[Reasoning] Clear Reasonings',
}

export const updateReasoning = createAction(
    ReasoningActionTypes.UpdateReasoning,
    props<{ entry: Reasoning }>()
);

export const clearReasonings = createAction(
    ReasoningActionTypes.ClearReasonings
);
